import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import Sidebar from "../Sidebar/sidebar";
import "./header.css";
import React, { useState } from "react";
import Loading from "../Loading/Loading";
import Button from "@mui/material/Button";
import image from "../Images/wishtree-logo.png";
function Header() {
  const [loading, setLoading] = useState(false);
  const cookies = new Cookies();
  const username = cookies.get("UserName");
  const navigator = useNavigate();
  // const clientId =
  //   "662915365340-ru45m3omcd4ap3elqoel9svluirock3m.apps.googleusercontent.com";
  const clientId = "469012308334-li4jlkc3da02go9f7uafnvc3b62khi9d.apps.googleusercontent.com"

  const onLogoutBtn = () => {
    setLoading(true);

    cookies.remove("UserLogin");
    cookies.remove("UserDetails");
    cookies.remove("adminRole");
    cookies.remove("sysAdminRole");
    cookies.remove("createdBy");
    cookies.remove("UserLoginAccessToken");
    cookies.remove("UserName")

    setTimeout(() => {
      navigator("/");
    }, 500);
  };

  return (
    <>
      {!loading ? (
        <div className="navigation w-[100%]">
          <Sidebar className="" />
          <div className="top_header">
            <AppBar sx={{ backgroundColor: "#fff", color: "#000", boxShadow: 1, left: "180px", width: "calc(100% - 180px)" }}>
              <Container maxWidth="xl" className="!pr-[50px]">
                <Toolbar disableGutters className="flex flex-row justify-end">
                  <div className="flex flex-row">
                    <div style={{ marginTop: "7px", marginRight: "30px" }}>
                      Welcome <span>{username ? username : ""}</span>
                    </div>{" "}
                    &nbsp;
                    <Button
                      onClick={onLogoutBtn}
                      variant="outlined"
                      sx={{
                        textTransform: "capitalize",
                        borderRadius: 1,
                        color: "#F05E67",
                        border: "1px solid #F05E67",
                        "&:hover": {
                          color: "#F05E67",
                          backgroundColor: "#fff",
                          border: "1px solid #F05E67",
                          opacity: 0.7
                        },
                      }}
                    >
                      Logout
                    </Button>
                  </div>
                </Toolbar>
              </Container>
            </AppBar>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
}
export default Header;
